import "core-js/stable";
import "regenerator-runtime/runtime";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import './_scroll-management.js';
import './_slider.js';
import './_shop-slider.js';
import './_product-gallery-slider.js';

import { toggleBodyClass } from './_class/_toggle';

document.querySelector('.menu-icon').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.menu-close').addEventListener('click', toggleBodyClass('menu-open'));

(function () {

  if (!document.body.classList.contains('woocommerce-shop') && !document.body.classList.contains('tax-product_cat')) return this;

  document.querySelector('.item-menu-btn').addEventListener('click', toggleBodyClass('item-menu-open'));
  document.querySelector('.product-category').addEventListener('click', toggleBodyClass('item-menu-open'));
  document.querySelector('.brand-menu-btn').addEventListener('click', toggleBodyClass('brand-menu-open'));
  document.querySelector('.product-brand').addEventListener('click', toggleBodyClass('brand-menu-open'));

})();

const setFillHeight = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
}

// 画面のサイズ変動があった時に高さを再計算する
window.addEventListener('resize', setFillHeight);

// 初期化
setFillHeight();
